import { AfterViewInit, Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AppComponentBase } from '@shared/app-component-base';
import { ClientDto, ClientServiceProxy, CommonServiceProxy, CommonSetting, CompanyDto, CompanyServiceProxy } from '@shared/service-proxies/service-proxies';
import { DefaultSettingService } from '@shared/services/default-setting.service';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'app-client-search-dialog',
  templateUrl: './client-search-dialog.component.html',
  styleUrls: ['./client-search-dialog.component.css']
})
export class ClientSearchDialogComponent extends AppComponentBase implements OnInit, AfterViewInit {

  displayedColumns  = ["companyCode", "code", "name", "actions"];
  displayedColumns1 = ["companyCode", "code", "name", "actions"];
  displayedColumns2 = ["code", "name", "actions"];
  dataSource: ClientDto[] = [];
  companies: CompanyDto[] = [];
  selectedCompanyId = 0;
  searchCode = "";
  searchName = "";
  searchIsDeleted = false;
  companyVisible = true;
  dataSource2:CommonSetting[]=[];

  @Output() selectedItem: EventEmitter<ClientDto> = new EventEmitter();
  @Output() selectedList: EventEmitter<ClientDto[]> = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    injector: Injector,
    private _dialogRef: MatDialogRef<ClientSearchDialogComponent>,
    private _clientService: ClientServiceProxy,
    private _defaultSettingsService: DefaultSettingService,
    private _service: CommonServiceProxy,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.selectedCompanyId = this._defaultSettingsService.getCompanyId();

    this.paginator.pageSize = this.pageSize;
    this.loadPageData();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        tap(() => this.loadPageData())
      )
      .subscribe();
  }

  private loadPageData() {
    this.spinner.show();
    this._service.getAll()
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe((result) => {
        this.dataSource2 = result;
        if (this.dataSource2 != null) {
          this.companyVisible = this.dataSource2[0].value == "true" ? true : false;
      
          if (this.companyVisible) {
            this.displayedColumns = this.displayedColumns1;
          }
          else if (!this.companyVisible) {
            this.displayedColumns = this.displayedColumns2;
          }
        }
      });
    this._clientService.getClientListPaged(this.selectedCompanyId, this.searchCode, this.searchName, this.searchIsDeleted, this.paginator.pageIndex * this.paginator.pageSize, this.paginator.pageSize)
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(results => {
        this.dataSource = results.items;
        this.totalRows = results.totalCount;
      });
  }

  reListData() {
    this.paginator.pageIndex = 0;
    this.loadPageData();
  }

  close(result: any): void {
    this._dialogRef.close(result);
  }
  returnAll() {
    this._dialogRef.close();
    this._clientService.getClientListPaged(this.selectedCompanyId, this.searchCode, this.searchName, this.searchIsDeleted, 0, 500)
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(results => {
        this.dataSource = results.items;
        this.totalRows = results.totalCount;
      });
    this.selectedList.emit();
  }

  onSelect(entity: ClientDto) {
    this._dialogRef.close();
    this.selectedItem.emit(entity);
  }
}
